<template>
  <b-overlay :show="isLoading" rounded="lg">
    <b-card title="Detail Bundle">
      <b-col cols="12">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <span>Bundle Name <span style="color:red">(*)</span></span>
              <b-form-input
                v-model="name"
                type="text"
                placeholder="Enter Bundle Name"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <span>Status</span>
              <b-form-input
                v-model="handlingBundle"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <span>Distribution Channel</span>
              <b-form-select v-model="selectChannel" @change="(value) => onSelectChannel()">
                <option
                  v-for="(selectOption, indexOpt) in listChannel"
                  :key="indexOpt"
                  :value="selectOption"
                >
                  {{ selectOption.name }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group>
              <span>Item Model <span style="color:red">(*)</span></span>
              <v-select
                v-model="selectItem"
                :options="searchItems"
                :disabled="!channelSelected"
                @search="ajaxSearch"
                placeholder="Search for items..."
                :clearSearchOnSelect="true"
              >
                <template #option="{ description, itemModel }">
                  {{ itemModel }}
                  <br />
                  <cite style="font-size:8px">{{ description }}</cite>
                </template>
                <template slot="selected-option" slot-scope="option" style="font-size:10px">
                  <cite style="font-size:10px">
                    {{ option.itemModel ? `${option.itemModel} - ${option.description}` : '' }}
                  </cite>
                </template>
              </v-select>
              <strong v-if="!channelSelected" style="color:red;"
                >Please Select Distribution Channel first</strong
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group>
              <span>Quantity <span style="color:red">(*)</span></span>
              <b-form-input
                type="number"
                placeholder="Quantity"
                required
                v-model="selectQuantity"
                :disabled="!channelSelected"
              >
              </b-form-input>
              <strong v-if="!channelSelected" style="color:red;"
                >Please Select Distribution Channel first</strong
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-button
              @click="addItemBundle"
              variant="outline-success"
              :disabled="!selectItem || Object.keys(selectItem).length === 0"
              style="margin-top:25px !important;"
            >
              Add Item
            </b-button>
          </b-col>

          <b-col cols="12" class="mt-2 table-responsive" >
            <strong v-if="items.length === 0" style="color:red;"
              >Item List Required. Please Add Item Model first</strong
            >
            <b-table :items="items" :fields="fields" show-empty>
              <template #cell(actions)="row">
                <b-button
                  size="sm"
                  @click="removeItem(row)"
                  class="mr-1"
                  variant="danger"
                >
                  <feather-icon icon="MinusIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
          <b-col cols="12">
            <b-button
              @click="doSaveBundle"
              :disabled="handlingBundle === 'Inactive'"
              variant="success"
            >
              Save Bundle
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "@/axios";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import lodash from "lodash";

export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      isLoading: false,
      fields: [
        { key: "itemModel", label: "Model" },
        { key: "price", label: "Price" },
        { key: "quantity", label: "Quantity" },
        { key: "actions", label: "Actions" },
      ],
      items: [],
      priceMaster: [],
      name: "",
      status: "",
      selectItem: {},
      selectQuantity: 1,
      selectChannel: {},
      listChannel: [],
      itemChannel: [],
      searchItems: [],
      totalPrice: 0,
    };
  },
  created() {
    this.isLoading = true;
    // First load all required data
    Promise.all([
      this.getItems({ status: "Active" }),
      axios.get("sales-and-purchase/drcc/pcode-distchan"),
      axios.get("sales-and-purchase/drcc/multi-price")
    ])
    .then(([itemsResponse, channelResponse, priceResponse]) => {
      // Process channel data
      this.listChannel = channelResponse.data.data;
      
      // Process price data
      this.priceMaster = priceResponse.data.data;
      
      // Now that we have all prerequisite data, load the bundle details
      return this.detailBundle(this.$route.params.bundleId);
    })
    .then((data) => {
      this.name = data.name;
      this.selectChannel = data.channel;
      this.onSelectChannel();
      this.items = data.items;
      this.items.map((x) => {
        return (x.price = x.price.$numberDecimal);
      });
      this.totalPrice = parseFloat(data.totalPrice.$numberDecimal);
      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.isLoading = false;
    });
  },
  methods: {
    ...mapActions({
      getItems: "item/getItems",
      detailBundle: "item/detailBundle",
      updateBundle: "item/updateItemBundle",
      getItemsForDealer: "item/getDealerItemToOrder",
    }),
    onSelectChannel(){
      this.searchItems = [];
      this.selectItem = {};
      
      if (!this.selectChannel || Object.keys(this.selectChannel).length === 0) {
        return;
      }
      
      // Load initial items after channel selection
      this.ajaxSearch("", (val) => {});
    },
    ajaxSearch: lodash.debounce(function(search, loading) {
      if (loading) loading(true);
      
      if (!this.selectChannel || Object.keys(this.selectChannel).length === 0) {
        if (loading) loading(false);
        return;
      }
      
      this.getItemsForDealer({
        industryType: this.selectChannel.name,
        item: search
      })
        .then((data) => {
          this.searchItems = data.map((item) => {
            // Handle item catalog only show active items (status = "")
            if (item.item.status === "") {
              item.price = parseFloat(item.price.$numberDecimal);
              return {
                label: `${item.item.itemModel} - ${item.item.description}`,
                description: item.item.description,
                itemModel: item.item.itemModel,
                ...item,
              };
            }
          }).filter(Boolean); // Filter out undefined items
          
          if (loading) loading(false);
        })
        .catch((e) => {
          console.log(e);
          if (loading) loading(false);
        });
    }, 500),
    addItemBundle() {
      if (!this.selectItem || Object.keys(this.selectItem).length === 0) {
        this.$bvToast.toast(`Please select an item first`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }
      
      let itemModel = this.selectItem.itemModel;
      let _id = this.selectItem.item._id;
      let price = this.selectItem.price;
      let quantity = this.selectQuantity;
      
      var check = this.items.find((x) => {
        return x.itemModel === itemModel;
      });
      if (check != undefined) {
        this.$bvToast.toast(`Item Already Exists`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
      } else {
        this.items.push({
          itemModel,
          id: _id,
          price: price,
          quantity: quantity,
        });
      }

      this.selectItem = {};
      this.selectQuantity = 1;
      this.totalPrice += parseFloat(price) * quantity;
    },
    removeItem(row) {
      let { itemModel, price, quantity } = row.item;

      let prevLength = this.items.length;

      this.items = this.items.filter((i) => {
        return !(i.itemModel === itemModel);
      });

      let nowLength = this.items.length;

      if (nowLength < prevLength) {
        this.totalPrice -= parseFloat(price) * quantity;
      }
    },
    doSaveBundle() {
      this.isLoading = true;
      let { name, selectChannel, totalPrice, items } = this;
      let channel = selectChannel._id;

      this.updateBundle({
        id: this.$route.params.bundleId,
        name,
        channel,
        totalPrice,
        items,
      })
        .then((data) => {
          this.$bvToast.toast("Update Bundle Success", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$router.push({ name: "bundles" });
        })
        .catch((e) => {
          this.$bvToast.toast("Update Bundle Fail", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapState({
      itemCatalogue: (state) => {
        return state.item.items.map((i) => {
          return Object.assign({
            value: i,
            text: `${i.description}(${i.itemModel})`,
          });
        });
      },
    }),
    handlingBundle() {
      let mapItemStatus = [];

      this.items.forEach((element) => {
        mapItemStatus.push(element.id.status);
      });

      //temporary inactive item will show N or A value
      var status = "Active";
      if (mapItemStatus.includes("N") || mapItemStatus.includes("A")) {
        status = "Inactive";
      }

      return status;
    },
    channelSelected() {
      return this.selectChannel && Object.keys(this.selectChannel).length > 0;
    }
  },
};
</script>

<style>
/* Vue select custom styling */
.v-select .vs__dropdown-toggle {
  height: 2.714rem;
  padding: 0;
}
</style>
